/* tslint:disable */

/**
 */
export class ShiftSupervisorForm {
    from_date?: string;
    to_date?: string;
    user_id?: number;
}
